import React from "react";
import Grid from "@material-ui/core/Grid/Grid";
import { Classes, ThemeType } from "@theme";
import { createStyles, withStyles } from "@material-ui/core";

type Props = {
  classes: Classes<typeof styles>;
  searchbar?: React.ReactNode;
  children?: React.ReactNode;
};

export const SearchForm: React.FC<Props> = (props) => {
  const { classes, searchbar, children } = props;

  return (
    <form id="search_page_search_form" data-test="SearchForm">
      <div className={classes.root}>
        {searchbar && <div className={classes.searchbar}>{searchbar}</div>}

        {children && (
          <Grid container spacing={1} className={classes.main}>
            {children}
          </Grid>
        )}
      </div>
    </form>
  );
};

export const styles = (theme: ThemeType) =>
  createStyles({
    root: {
      ...theme.fixedGrid,
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      position: "relative"
    },

    searchbar: {
      marginTop: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },

    main: {
      alignItems: "flex-end",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      marginTop: theme.spacing(2),
      width: "100%",
      margin: 0,
      zIndex: 2,
      "&:last-child": {
        paddingBottom: theme.spacing(2)
      }
    }
  });

export default withStyles(styles)(SearchForm);
